<template>
    <div>
        <balance></balance>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import Pagination from 'components/pagination';
    import Balance from '../balance';
    import api from '../../api';

    export default {
        name: 'records',
        props: ['uid'],
        data() {
            return {
                pagination: {
                    page: 1,
                    size: 10
                }
            };
        },
        computed: {
            ...mapState('withdrawalAudit', [
                'userRecords',
                'userDetailTotal',
                'userWallet'
            ])
        },
        components: {
            Pagination,
            Balance
        },
        methods: {
            ...mapActions('withdrawalAudit', [
                'getUserRecords',
                'resetUserRecords',
                'getUserWallet','getRebateAmount'
            ]),
            getList() {
                this.getUserRecords({
                    userId: this.uid,
                    ...this.pagination
                });
            },
            handleCurrentChange(pagination) {
                this.pagination = pagination;
                this.getList();
            }
        },
        mounted() {
            this.getUserWallet({userId: this.uid});
            this.getRebateAmount({userId: this.uid});
        },
        destroyed() {
            this.resetUserRecords();
        }
    };
</script>
